$shm_hitalama_hovered $mol_plugin
	hovered? false
	event *
		^
		pointerenter? <=> pointerenter? null
		pointerleave? <=> pointerleave? null
